export default "__VITE_ASSET__CpSu$oWE__"